import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76508bd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iapp" }
const _hoisted_2 = {
  key: 0,
  class: "linkprevue"
}
const _hoisted_3 = {
  key: 0,
  id: "loader-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "wrapper" }
const _hoisted_8 = { class: "card-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "card-info" }
const _hoisted_11 = { class: "card-text" }
const _hoisted_12 = { class: "card-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.validUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "slidedown2",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (!_ctx.response && _ctx.validUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "slidedown",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.response)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default", {
                      img: _ctx.response.image,
                      title: _ctx.response.title,
                      description: _ctx.response.description,
                      url: _ctx.url
                    }, () => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.response.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.response.image
                              }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h1", null, _toDisplayString(_ctx.response.title), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.response.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.showButton)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "btn btn-rounded btn-outline-secondary float-right",
                                  href: "javascript:;",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewMore && _ctx.viewMore(...args)))
                                }, _toDisplayString(_ctx.t('viewmore')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ], true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}